<script setup lang="ts">
// Full-height column layout: fixed header, scrolling body, optional fixed
// footer. Replaces the `.shell` pattern that AppView and AdminView currently
// hand-roll in scoped styles.
</script>

<template>
  <div class="shell">
    <slot name="header" />
    <div class="shell-body">
      <slot />
    </div>
    <slot name="footer" />
  </div>
</template>

<style scoped>
/* Flex column so slot children can either fill remaining space (a canvas
   in AppView, flex: 1 1 auto with min-height: 0) or scroll naturally as
   content grows past the viewport (a routed view's content area). */
.shell-body {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}
</style>
